var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M44 54H19v1h1v1h24v-1h1v-1h-1z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8h2V6h-4v2h2zM19 10V8h-2v2h2zM25 6h2V4h-4v2h2zM29 4h8V2H27v2h2zM45 10h2V8h-2v2zM48 10h-1v39h-2v2h4V10h-1zM37 6h4V4h-4v2zM41 8h4V6h-4v2zM17 49V10h-2v41h4v-2h-2zM24 47h-5v2h5v-2zM27 49h-3v2h5v-2h-2zM45 47h-5v2h5v-2zM35 47h-6v2h6v-2zM38 49h-3v2h5v-2h-2z",
    fill: "#64438E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39v6h2v-1h2v1h2v2h-5v2h-2V10h2v1h-1v28zM27 47h-3v2h5v-2h-2zM38 47h-3v2h5v-2h-2zM35 45h-2v-1h-2v1h-2v2h6v-2zM25 7h2V6h-4v1h2zM21 9h2V8h-4v1h2zM45 40v5h-1v-1h-2v1h-2v2h5v2h2V10h-2v30zM37 4H27v1h5v1h5V4zM45 8h-4v2h4V8zM41 6h-4v2h4V6z",
    fill: "#EDD3FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10h-3V8h-4V6h-5V5h-5v2h-4v2h-4v2h-1v34h2v-1h2v1h2v2h5v-2h2v-1h2v1h2v2h5v-2h2v-1h2v1h1V10h-1z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28v2h2v-2h-2zM42 28h-1v2h2v-2h-1z",
    fill: "#F696C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13v-2h-1v4h1v-2zM30 10h-1v1h1v-1zM30 15h-1v1h1v-1zM31 16h-1v1h1v-1zM31 17v1h2v-1h-2zM31 9h-1v1h1V9zM35 15h-1v1h1v-1zM35 10h-1v1h1v-1zM33 9V8h-2v1h2zM34 16h-1v1h1v-1zM34 9h-1v1h1V9zM35 11v4h1v-4h-1z",
    fill: "#64438E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-2v4h1v-1h1v-1h1v-2h-1z",
    fill: "#C260FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13h-1v2h1v1h1v1h1v-4h-2zM34 11v-1h-1V9h-1v4h3v-2h-1z",
    fill: "#DEA8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13h1V9h-1v1h-1v1h-1v2h2z",
    fill: "#EDD3FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28h-2v2h2v-2zM33 30h-4v2h6v-2h-2zM36 28h-1v2h2v-2h-1zM23 24v2h4v-2h2v-4h-2v-2h-4v2h-2v4h2zM35 20v4h2v2h4v-2h2v-4h-2v-2h-4v2h-2zM15 36h-1v1h1v-1zM14 38v-1h-2v1h2zM14 30h-1v1h1v-1zM15 29h-1v1h1v-1zM13 31h-1v1h1v-1zM9 39h3v-1H8v1h1zM8 33v1h2v-1H8zM10 32v1h2v-1h-2zM7 35v3h1v-4H7v1zM50 36h-1v1h1v-1zM51 30h-1v1h1v-1zM50 29h-1v1h1v-1zM52 31h-1v1h1v-1zM56 34v4h1v-4h-1zM51 37h-1v1h2v-1h-1zM54 38h-2v1h4v-1h-2zM55 33h-1v1h2v-1h-1zM53 32h-1v1h2v-1h-1z",
    fill: "#64438E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35h-1v1h1v-1zM12 36v1h2v-1h-2zM10 37H8v1h4v-1h-2zM50 35h-1v1h1v-1zM51 36h-1v1h2v-1h-1zM55 37h-3v1h4v-1h-1z",
    fill: "#EDD3FD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14 31h-1v1h-1v1h-2v1H8v3h4v-1h2v-1h1v-5h-1v1zM55 34h-1v-1h-2v-1h-1v-1h-1v-1h-1v5h1v1h2v1h4v-3h-1z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9V8h-1v8h2V9h-1zM17 9h-1v7h2V8h-1v1zM34 1v3h-2V3h-1v1h-1V1h-2v15h2v-4h4v4h2V1h-2zM23 5h-1v11h2V4h-1v1zM41 4h-1v12h2V5h-1V4z",
    fill: "#FFDB72"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1V8h-2v1h1v7h-2V8h1V6h-2v10h-2V5h1v1h1V4h-4v1h1v11h-2V4h1V2h-4V0H27v2h-4v2h1v12h-2V5h1V4h-4v2h1V5h1v11h-2V6h-2v2h1v8h-2V9h1V8h-2v8h-2v2h38v-2h-1zM38 3h1v13h-2V3h1zm-3-2h1v15h-2V1h1zm-3 0h1v15h-2V1h1zm-4 0h2v15h-2V1zm-3 14V3h2v13h-2v-1z",
    fill: "#FFBE00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44 6V5h-1v11h2V6h-1zM20 6h-1v10h2V5h-1v1zM31 1v15h2V1h-2zM25 3v13h2V3h-2zM37 3v13h2V3h-2z",
    fill: "#FFEBB1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9V7h-1v4h1V9zM30 6h-1v1h1V6zM35 6h-1v1h1V6zM35 7v4h1V7h-1zM30 11h-1v1h1v-1zM32 12h-2v1h4v-1h-2zM35 11h-1v1h1v-1zM32 6h2V5h-4v1h2z",
    fill: "#C8C8C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34 7v4h1V7h-1zM32 11h-2v1h4v-1h-2zM32 7h2V6h-4v1h2zM30 9V7h-1v4h1V9z",
    fill: "#EAEAEA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7h-3v4h4V7h-1z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36 6V5h-1V4h-6v1h-1v1h-1v6h1v1h1v1h6v-1h1v-1h1V6h-1zm0 2v3h-1v1h-1v1h-4v-1h-1v-1h-1V7h1V6h1V5h4v1h1v1h1v1z",
    fill: "#646464"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29 4h-1v1h1V4zM27 10V6h-1v6h1v-2zM28 5h-1v1h1V5zM28 12h-1v1h1v-1zM37 12h-1v1h1v-1zM37 5h-1v1h1V5zM31 4h4V3h-6v1h2zM37 6v6h1V6h-1zM36 4h-1v1h1V4zM33 14h-4v1h6v-1h-2zM29 13h-1v1h1v-1zM36 13h-1v1h1v-1z",
    fill: "#3C3C3C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13 38h-1v1h1v-1zM11 36h-1v1h1v-1zM9 34H8v1h1v-1zM7 32H6v1h1v-1z",
    fill: "#876526"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30H4v1h1v-1z",
    fill: "#868686"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38h-1v1h1v-1zM13 37h-1v1h1v-1zM11 35h-1v1h1v-1zM9 33H8v1h1v-1zM7 31H6v1h1v-1zM12 36h-1v1h1v-1zM10 34H9v1h1v-1zM8 32H7v1h1v-1zM6 30H5v1h1v-1z",
    fill: "#483514"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39h-1v1h1v-1zM12 38h-1v1h1v-1zM10 36H9v1h1v-1zM8 34H7v1h1v-1zM6 32H5v1h1v-1zM11 37h-1v1h1v-1zM9 35H8v1h1v-1zM7 33H6v1h1v-1zM5 31H4v1h1v-1z",
    fill: "#281D0A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14 39h-1v1h1v-1zM12 37h-1v1h1v-1zM10 35H9v1h1v-1zM8 33H7v1h1v-1zM6 31H5v1h1v-1z",
    fill: "#644C1E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28H5v1H4v1h2v-1h1v-1H6zM3 31H2v2h1v-1h1v-2H3v1z",
    fill: "#C8C8C8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H3v1h1v-1zM3 29H2v1h1v-1zM5 27H4v1h1v-1zM2 30H1v1h1v-1zM0 32v4h1v-5H0v1zM2 36H1v1h1v-1zM3 35v-2H2v3h1v-1zM4 32H3v1h1v-1zM9 26H5v1h5v-1H9zM11 27h-1v1h1v-1zM8 28H7v1h3v-1H8zM7 29H6v1h1v-1z",
    fill: "#3C3C3C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4 29H3v1h1v-1zM5 28H4v1h1v-1zM3 30H2v1h1v-1zM1 32v4h1v-5H1v1zM9 27H5v1h5v-1H9z",
    fill: "#EAEAEA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3 28H2v1h1v-1z",
    fill: "#868686"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37H15v14h4v-2h-3v-5h2v-1h-2v-3h2v3h1v-3h12v7h-2v2h6v-2h-3v-2h1v-1h-1v-4h13v3h1v-3h2v3h-2v1h2v5h-3v2h4V37h-1zm-25 2h-7v-1h8v1h-1zm7 0h-5v-1h6v1h-1zm2 0v-1h1v1h-1zm6 0h-4v-1h5v1h-1zm10 0h-8v-1h8v1z",
    fill: "#000"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-3v2h5v-2h-2zM24 47h-5v2h5v-2zM33 41v2h1v-3h-1v1zM34 43h-1v1h1v-1zM38 49h-3v2h5v-2h-2zM45 47h-5v2h5v-2z",
    fill: "#000"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h-2v1h2zM29 45v1h-1v2h-2v1h3v-2h2v-2h-2zM26 47v-3h-3v-1h-1v-1h-1v-1h-1v1h-1v1h1v1h-1v1h3v2h1v-1h2v1h1zM17 46h-1v3h2v-2h-1v-1zM33 43h-1v1h1v-1zM35 43h-1v1h1v-1zM45 47v2h2v-2h-2zM48 42h-1v1h1v-1zM33 45h-1v2h2v-3h-1v1zM46 44v-1h-2v1h2zM41 43h-1v1h-3v1h2v2h2v-3h1v-2h-1v1z",
    fill: "#CAB983"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40h-2v2h-1v1h2v-2h3v-1h-2zM33 38h-1v1h1v-1z",
    fill: "#CAB983"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42v-1h-2v1h1v1h-2v-1h-1v-1h-2v1h-1v2h3v1h2v-1h1v1h2v-2h-1v-1zM16 42v1h2v-1h-2zM23 46v1h2v-1h-2zM17 44h-1v2h1v1h1v-2h-1v-1zM41 42h-1v-1h-1v2h-2v-1h1v-2h-3v1h-1v1h2v3h1v-1h3v-1h1v-1zM43 46h-2v1h4v-1h-2zM46 44v1h-1v1h2v-1h1v-1h-2zM42 44h-1v1h1v-1zM37 47h1v1h1v-3h-2v2zM35 48v1h2v-1h-2zM35 46v-1h-1v2h1v-1zM20 40h-1v1h1v-1zM45 41v-1h-2v2h-1v2h2v-1h1v-1h-1v-1h1zM29 38h-4v1h6v-1h-2zM33 38h-1v1h1v-1zM36 39h3v-1h-5v1h2zM24 39v-1h-8v1h8zM47 38h-7v1h8v-1h-1z",
    fill: "#66553B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-9v1h1v1h1v1h1v-1h1v-1h2v1h2v-1h2v2h1v-3h-2zM18 42v-2h-2v2h2zM28 45h-2v2h-2v2h2v-1h2v-2h1v-2h-1v1zM20 45h-1v-1h1v-1h-2v1h-1v1h1v4h1v-2h3v-2h-2zM42 42h1v-2h-1v1h-2v1h2zM35 40h-1v1h1v-1zM32 41v2h1v-3h-1v1zM46 45v-1h-4v1h-1v1h4v-1h1zM47 40h-1v3h1v-1h1v-2h-1zM39 48h-1v-1h-1v-2h-1v-3h-2v1h1v1h-1v1h1v3h2v1h3v-2h-1v1zM20 41h-1v1h1v-1zM45 41h-1v1h1v-1zM47 46h-2v1h2v2h1v-4h-1v1z",
    fill: "#51774E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40H19v3h-1v1h-2v5h3v-2h5v2h5v-2h2v-7h-2z",
    fill: "#334B8B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v-1h-2v3h2v-2zM33 42v-2h-1v4h1v-2zM47 40h-1v3h2v-3h-1z",
    fill: "#334B8B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45 42v-2H34v4h-1v1h-1v2h3v2h5v-2h5v2h3v-5h-2v-1h-1v-1z",
    fill: "#334B8B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h-4v1h6v-1h-2z",
    fill: "#A97955"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38h-1v1h1v-1z",
    fill: "#E4C599"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38h-3v1h5v-1h-2zM22 38h-6v1h8v-1h-2zM47 38h-7v1h8v-1h-1z",
    fill: "#A97955"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37H15v14h4v-2h-3v-5h2v-1h-2v-3h2v3h1v-3h12v7h-2v2h6v-2h-3v-2h1v-1h-1v-4h13v3h1v-3h2v3h-2v1h2v5h-3v2h4V37h-1zm-25 2h-7v-1h8v1h-1zm7 0h-5v-1h6v1h-1zm2 0v-1h1v1h-1zm6 0h-4v-1h5v1h-1zm10 0h-8v-1h8v1z",
    fill: "#001E6E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-3v2h5v-2h-2zM24 47h-5v2h5v-2zM33 41v2h1v-3h-1v1zM34 43h-1v1h1v-1zM38 49h-3v2h5v-2h-2zM45 47h-5v2h5v-2z",
    fill: "#001E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiner);
export default __webpack_public_path__ + "static/media/miner.af16ad3e2ec61084fdd2ae0779845021.svg";
export { ForwardRef as ReactComponent };